module.exports = __webpack_public_path__ + "static/media/coronatracker-goa.4ebf66ef.jpg";